import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'

export class ActivateQuizVersionUseCase {
  private quizRepository: IQuizRepository

  constructor(quizRepository: IQuizRepository) {
    this.quizRepository = quizRepository
  }

  async execute(quizId: number, versionId: number): Promise<Quiz> {
    // Récupérer le quiz complet pour valider la version
    const quiz = await this.quizRepository.fetchQuiz(quizId)
    const version = quiz.findVersionById(versionId)

    if (!version) {
      throw new Error(`Version ${versionId} non trouvée pour le quiz ${quizId}`)
    }

    // Vérifier que la version brouillon a au moins 5 questions valides
    if (version.isDraft) {
      const validQuestions = version.questions.filter((question) => question.isValid()).length
      const requiredQuestions = 5

      if (validQuestions < requiredQuestions) {
        const missing = requiredQuestions - validQuestions
        throw new Error(
          `Cette version ne peut pas être activée car elle n'a que ${validQuestions} question${validQuestions > 1 ? 's' : ''} valide${validQuestions > 1 ? 's' : ''} sur les ${requiredQuestions} requises (${missing} manquante${missing > 1 ? 's' : ''})`
        )
      }
    }

    return await this.quizRepository.activateQuizVersion(quizId, versionId)
  }
}
